import * as React from 'react';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';


export default function Banner() {
  return (
    <div>
      <Stack direction="row" spacing={2} sx={{alignContent:"center", justifyContent:"center", backgroundColor: "#f04444", padding: "10px"}}>
        <Paper elevation={0}><img src="/assets/BenowLogo2.jpg" style={{ width: '60px', height: 'auto', borderRadius:"5px",padding:"2px", margin:"5px"}}/></Paper>
      </Stack>
    </div>
  );
}